module.exports = __webpack_public_path__ + "static/media/smallBusiness.134787be.jpg";